import React from 'react';
import { AdminProductAttributeListWithOptions_adminProductAttributes } from '@api/graphql/types';
import DeleteButton from '@components/DeleteButton';

interface Props {
    attribute: AdminProductAttributeListWithOptions_adminProductAttributes;
    attributeOptionIds: Array<(string | null)>;
    onRemove: (value: string) => void;
}

interface State {
    addOption: string;
}

class ProductAttributeField extends React.Component<Props, State> {
    public state = {
        addOption: '',
    };

    private onRemove = (option: string) => {
        this.props.onRemove(option.toString());
    }

    public render() {
        const { attribute, attributeOptionIds } = this.props;
        const attributeOptions = attribute.options && attribute.options.filter((option) => attributeOptionIds.includes(option.id));
        if (attributeOptions) {
            return (
                <>
                    {attributeOptions.map((attributeOption) => {
                        return (
                            <div key={attributeOption.id} className="row">
                                <div className="col-sm-10">
                                    <div className="pull-right">
                                        {attributeOption.label}
                                    </div>
                                </div>
                                <div className="col-sm-2 pull-right">
                                    <DeleteButton className="btn-xs btn-block" onClick={this.onRemove} value={attributeOption.id}>
                                        <i className="fa fa-trash" />
                                    </DeleteButton>
                                </div>
                            </div>
                        );
                    })}
                </>
            );
        }
        return '';
    }

}

export default ProductAttributeField;



// WEBPACK FOOTER //
// ./src/modules/Product/components/ProductAttributeField.tsx